import "./Tag.css";

function Tag({ tool }) {
    return (
        <div className="tag">
            <p>{tool}</p>
        </div>
    )
}

export default Tag